import { Component } from '@angular/core';

@Component({
  selector: 'app-touch-guide',
  templateUrl: './touch-guide.component.html',
  styleUrls: ['./touch-guide.component.scss']
})
export class TouchGuideComponent { }



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/touch-guide.component.ts